export default "__VITE_ASSET__DqqUpH43__"